import { combineReducers } from "redux"
import game from './gameReducer'

const packageReducers = combineReducers({
    game
})
export default packageReducers;